import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationStart, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { IdleTimeoutService } from './core/services/idle-timeout.service';
import { NetworkService } from './core/services/network.service';
import { ThemeService } from './core/theme.service';
import { NetworkModalComponent } from './shared/components/network-modal/network-modal.component';
import { AuthService } from './auth/services/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NetworkModalComponent],
  template: `
    <router-outlet></router-outlet>
    <app-network-modal></app-network-modal>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
        height: 100%;
      }
    `,
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  isDark = false;
  title = 'trex-csq';

  constructor(
    private themeService: ThemeService,
    private idleService: IdleTimeoutService,
    private router: Router,
    private networkService: NetworkService,
    private authService: AuthService, 
  ) {}

  ngOnInit(): void {
    this.authService.storeEventRedirectFromUrl();

    setTimeout(() => {
      this.networkService.checkAndShowOfflineModal();
    }, 1000);

    setTimeout(() => {
      this.idleService.startWatching();
    }, 2000);

    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe(() => {
        this.idleService.resetIdleTimer();
      });
  }

  toggleTheme() {
    this.isDark = !this.isDark;
    this.themeService.toggleTheme(this.isDark);
  }

  ngOnDestroy(): void {
    this.idleService.stopWatching();
  }
}
